<canvas #canvasDocument class="canvas"></canvas>
<footer class="footer">
  <div class="footer__fps">{{ fps }}</div>
  <div class="content__action" *ngFor="let controlAction of renderActions.keys()">
    <div class="content__action-name" [class.is-active]="renderActions.get(controlAction)">
      {{ renderActionsTypes.get(controlAction) }}
    </div>
  </div>
  <div class="footer__button-group"></div>
</footer>
